import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import Item from "@/models/PlatinumWidget/Accordion/Item/Item";
import orderBy from "lodash/orderBy";

export default class Accordion extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/accordion';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetAccordion';

    static model_name = 'Accordion';

    static fields() {
        return {
            id: this.number(null).nullable(),
            display_type: this.attr(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            items: this.hasMany(Item, 'platinum_widget_accordion_id'),
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Items() {
        return orderBy(this.getRelated('items'), 'rank');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
